import { evaluate } from '/webpack/assets/js/triggerConditions.js';

$(function () {
	const $wrappers = $('[data-required-trigger]');
	if (!$wrappers.length) return;

	const resolveCondition = function (condition) {
		return {
			$trigger: $(`[name="${condition.triggerHtmlName}"]`),
			expectedValue: condition.value,
		};
	};

	const setLabelState = function (targetControlName, required) {
		$(`label[data-label-control-name="${targetControlName}"]`).toggleClass('required', !!required);
	};

	const setSelectPrompt = function ($promptOption, required) {
		$promptOption.attr('disabled', required).attr('hidden', required);

		const $select = $promptOption.parents('select');

		if ($select[0] && $select[0].tomselect) {
			$select[0].tomselect.clearOptions();
			$select[0].tomselect.sync();
			$select[0].tomselect.refreshOptions(false);

			if ($select.val() === "" || $select.val() === null) {
				$select[0].tomselect.clear(true);
			}
		}
	};

	// Init
	$wrappers.each(function () {
		const $wrapper = $(this);
		const $promptOption = $wrapper.find('option[value=""]');
		const requiredTriggerData = $wrapper.data('required-trigger');

		if (!requiredTriggerData) return;

		const refresh = function () {
			const shouldBeRequired = evaluate(requiredTriggerData.ruleList, resolveCondition);

			setLabelState(requiredTriggerData.targetControlName, shouldBeRequired);

			if ($promptOption.length > 0) {
				setSelectPrompt($promptOption, shouldBeRequired);
			}
		};

		// Init listeners — bind each trigger once even when it repeats across conditions/rules
		const triggerHtmlNameSet = new Set();
		for (const conditionList of requiredTriggerData.ruleList) {
			for (const condition of conditionList) {
				triggerHtmlNameSet.add(condition.triggerHtmlName);
			}
		}

		for (const triggerHtmlName of triggerHtmlNameSet) {
			$(document).on('change input', `[name="${triggerHtmlName}"]`, refresh);
		}

		refresh();
	});
});